export class PositionCloseReqeustData {
    constructor(position, quantityToClose, isAllowOTHTrading, placedFrom) {
        this.position = position;
        this.quantityToClose = quantityToClose;
        this.isAllowOTHTrading = isAllowOTHTrading;
        this.placedFrom = placedFrom;
    }
}
